import React, { Component } from 'react';

export default class DataTableHeader extends Component {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <thead style={{
                fontFamily: this.props.option.fontFamilyHeader,
                fontSize: this.props.option.fontSizeHeader,
                color: this.props.option.fontColorHeader,
                backgroundColor: this.props.option.backgroundColorHeader,
            }}>
                <tr>
                    {
                        this.props.columns.map((c, i) => (
                            <th style={{
                                padding: `${this.props.option.paddingVHeader}px ${this.props.option.paddingHHeader}px`,
                                fontWeight: this.props.option.isBoldHeader ? 'bold' : 'normal',
                                borderLeft: i === 0 ? `${this.props.option.borderWidthTable}px ${this.props.option.borderStyleTable} ${this.props.option.borderColorTable}` : ``,
                                borderTop: `${this.props.option.borderWidthTable}px ${this.props.option.borderStyleTable} ${this.props.option.borderColorTable}`,
                                borderBottom: `${this.props.option.borderWidthTable}px ${this.props.option.borderStyleTable} ${this.props.option.borderColorTable}`,
                                borderRight: `${this.props.option.borderWidthTable}px ${this.props.option.borderStyleTable} ${this.props.option.borderColorTable}`
                            }} key={i}>{c.name || c.expression}</th>
                        ))
                    }
                </tr>
            </thead>
        );
    }
}
